import { Button, NavLink } from '../../components';
import { CampaignsListTemplate, useCampaigns } from '../../templates';

const Prompts = () => {
  const listResult = useCampaigns();

  return (
    <CampaignsListTemplate
      listResult={listResult}
      columns={[
        {
          sortName: 'name',
          header: 'Campaign Name',
          cellClassName: 'text-small font-semibold',
          getValue: ({ name }) => name,
        },
        {
          header: 'Actions',
          align: 'right',
          getValue: item => (
            <NavLink to={`/system_prompts/${item.id}`}>
              <Button icon="eye" tooltip="View Prompts" />
            </NavLink>
          ),
        },
      ]}
    />
  );
};

export default Prompts;
